// extracted by mini-css-extract-plugin
export var icon = "_bo-3";
export var subtitle = "_bo-2";
export var title = "_bo-1";
export var value = "_bo-0";